/**
 * Permissions for the application
 */
export const PERMISSIONS = {
    // Auth Service Permission Codes
    AUTH_SVC_AUTH_REGISTER: "AUTH1",
    AUTH_SVC_AUTH_HISTORY_LIST_BY_DATE: "AUTH7",

    AUTH_SVC_PERMISSIONS_CODES_LIST: "AUTH8",
    AUTH_SVC_PERMISSIONS_GROUPS_LIST: "AUTH9",
    AUTH_SVC_PERMISSIONS_GROUPS_FIND: "AUTH10",
    AUTH_SVC_PERMISSIONS_GROUPS_CREATE: "AUTH11",
    AUTH_SVC_PERMISSIONS_GROUPS_UPDATE: "AUTH12",
    AUTH_SVC_PERMISSIONS_GROUPS_DELETE: "AUTH13",

    // Account Management
    AUTH_SVC_USER_ME: "AUTH14",
    AUTH_SVC_USER_LIST: "AUTH15",
    AUTH_SVC_USER_FIND: "AUTH16",
    AUTH_SVC_USER_UPDATE: "AUTH17",
    AUTH_SVC_USER_DELETE: "AUTH18",

    // API Key Management Permissions
    AUTH_SVC_API_KEYS_VIEW: "AUTH19",
    AUTH_SVC_API_KEYS_MANAGE: "AUTH20",

    // Shortlinks Management Permissions
    MISC_SVC_SHORTLINKS_LIST: "MISC_LI1",
    MISC_SVC_SHORTLINKS_ACTIONS: "MISC_AC1",
    MISC_SVC_SHORTLINKS_CREATE: "MISC_CR1",
    MISC_SVC_SHORTLINKS_UPDATE: "MISC_UP1",
    MISC_SVC_SHORTLINKS_DELETE: "MISC_DE1",
    MISC_SVC_SHORTLINKS_SOURCE_MEDIUM_MANAGE: "MISC_SM1",

    // Offers Management Permissions
    MISC_SVC_OFFERS_LIST: "MISC_OF1",
    MISC_SVC_OFFERS_CREATE: "MISC_OF2",
    MISC_SVC_OFFERS_UPDATE: "MISC_OF3",
    MISC_SVC_OFFERS_DELETE: "MISC_OF4",

    // Templates Management Permissions
    MISC_SVC_TEMPLATES_LIST: "MISC_TM1",
    MISC_SVC_TEMPLATES_CREATE: "MISC_TM2",
    MISC_SVC_TEMPLATES_UPDATE: "MISC_TM3",
    MISC_SVC_TEMPLATES_DELETE: "MISC_TM4",

    // Sections Management Permissions
    MISC_SVC_SECTIONS_LIST: "MISC_SC1",
    MISC_SVC_SECTIONS_CREATE: "MISC_SC2",
    MISC_SVC_SECTIONS_UPDATE: "MISC_SC3",
    MISC_SVC_SECTIONS_DELETE: "MISC_SC4",

    // Calculators Management Permissions
    MISC_SVC_CALCULATORS_LIST: "MISC_CA1",
    MISC_SVC_CALCULATORS_CREATE: "MISC_CA2",
    MISC_SVC_CALCULATORS_UPDATE: "MISC_CA3",
    MISC_SVC_CALCULATORS_DELETE: "MISC_CA4",

    // Strings Management Permissions
    MISC_SVC_STRINGS_LIST: "MISC_ST1",
    MISC_SVC_STRINGS_CREATE: "MISC_ST2",
    MISC_SVC_STRINGS_UPDATE: "MISC_ST3",
    MISC_SVC_STRINGS_DELETE: "MISC_ST4",

    // Extra Treatments Management Permissions

    APP_SVC_EXTRA_TREATMENTS_CREATE: "APP_ET2",
    APP_SVC_EXTRA_TREATMENTS_UPDATE: "APP_ET3",
    APP_SVC_EXTRA_TREATMENTS_DELETE: "APP_ET4",

    // Promotions Management Permissions
    MISC_SVC_PROMOTIONS_LIST: "MISC_PR1",
    MISC_SVC_PROMOTIONS_CREATE: "MISC_PR2",
    MISC_SVC_PROMOTIONS_UPDATE: "MISC_PR3",
    MISC_SVC_PROMOTIONS_DELETE: "MISC_PR4",

    // Feedbacks Management Permissions
    MISC_SVC_FEEDBACKS_LIST: "MISC_FB1",
    MISC_SVC_FEEDBACKS_CREATE: "MISC_FB2",
    MISC_SVC_FEEDBACKS_UPDATE: "MISC_FB3",
    MISC_SVC_FEEDBACKS_DELETE: "MISC_FB4",

    // Tutorials Management Permissions
    MISC_SVC_TUTORIALS_LIST: "MISC_TU1",
    MISC_SVC_TUTORIALS_CREATE: "MISC_TU2",
    MISC_SVC_TUTORIALS_UPDATE: "MISC_TU3",
    MISC_SVC_TUTORIALS_DELETE: "MISC_TU4",

    // Machine Caller Management Permissions
    MISC_SVC_MACHINE_CALLER_LIST: "MISC_MC1",

    // ElitAI Management Permissions
    ELITAI_SVC_LIST_SIMULATIONS: "ELITAI1",
    ELITAI_SVC_SIMULATIONS_CREATE: "ELITAI_AI2",
    APP_SVC_STRINGS_LIST: "APP_ST1",
    APP_SVC_PROMOTIONS_LIST: "APP_PR1",
    APP_SVC_EXTRA_TREATMENTS_LIST: "APP_ET1",
    APP_SVC_TUTORIALS_LIST: "APP_TU1",
    APP_SVC_FEEDBACKS_LIST: "APP_FB1",
};

/**
 * Defines the permissions required to access specific pages
 */
export const PAGE_PERMISSIONS = {
    HOME: [],

    USERS: [PERMISSIONS.AUTH_SVC_USER_LIST],

    PERMISSIONS: [PERMISSIONS.AUTH_SVC_PERMISSIONS_GROUPS_LIST],

    PATIENTS: [],
    PATIENT_DETAILS: [],

    STRINGS: [PERMISSIONS.APP_SVC_STRINGS_LIST],

    PROMOTIONS: [PERMISSIONS.APP_SVC_PROMOTIONS_LIST],

    EXTRA_TREATMENTS: [PERMISSIONS.APP_SVC_EXTRA_TREATMENTS_LIST],

    CALCULATORS: [PERMISSIONS.MISC_SVC_CALCULATORS_LIST],

    OFFERS: [PERMISSIONS.MISC_SVC_OFFERS_LIST],

    TEMPLATES: [PERMISSIONS.MISC_SVC_TEMPLATES_LIST],
    TEMPLATE_EDIT: [PERMISSIONS.MISC_SVC_TEMPLATES_UPDATE],

    SECTIONS: [PERMISSIONS.MISC_SVC_SECTIONS_LIST],
    SECTION_EDIT: [PERMISSIONS.MISC_SVC_SECTIONS_UPDATE],

    ELITAI_SIMULATIONS: [PERMISSIONS.ELITAI_SVC_LIST_SIMULATIONS],

    MACHINE_CALLER: [PERMISSIONS.MISC_SVC_MACHINE_CALLER_LIST],

    TUTORIALS: [PERMISSIONS.APP_SVC_TUTORIALS_LIST],

    FEEDBACKS: [PERMISSIONS.APP_SVC_FEEDBACKS_LIST],

    PRP_POS: [],
    HP_POS: [],

    // Shortlinks page permissions
    SHORTLINKS: [PERMISSIONS.MISC_SVC_SHORTLINKS_LIST],
    AGENT_CALENDARS: ["MISC_OF1"],
};
